import Head from "next/head";

import config from "config";
import { AuthLayout } from "auth";
import ProjectListing from "data-apps/network-field-service/Projects";

const ProjectListingPage = () => {
  return <ProjectListing />;
};

ProjectListingPage.getLayout = (page) => (
  <>
    <Head>
      <title>{config.SITE_NAME} | Network Field Service</title>
    </Head>
    {/* We want users to still see their files. */}
    <AuthLayout stopExpiredUsers={false}>{page}</AuthLayout>
  </>
);

export default ProjectListingPage;
